import { call, put, select, takeLatest } from "redux-saga/effects";
import { LOAD_CLASSES, UPDATE_CLASS } from "./constants";
import {
  loadClassesSuccess,
  loadClassesError,
  updateClassSuccess,
  updateClassError,
} from "./actions";

import history from "utils/history";
import requestUtil from "utils/request";
import requestWrapper from "utils/requestWrapper";
import _local from "utils/localStorageUtils";

export function* loadClasses() {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();

    // we get the campaigns linked to the classes
    const itemsList = yield requestWrapper(
      "GET",
      `classes/list`,
      "",
      currentUser.token,
    );

    if (!itemsList) {
      yield put(loadClassesSuccess(false));
    } else {
      const firstElem = itemsList.data[0];
      yield put(loadClassesSuccess(itemsList, firstElem));
    }
  } catch (error) {
    yield put(loadClassesError(error));
  }
}

export function* updateClass(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { classDetail } = action;

    let updatedClass = false,
      isNew = !classDetail.hasOwnProperty("_id");

    if (isNew) {
      updatedClass = yield requestWrapper(
        "POST",
        "classes/new",
        classDetail,
        currentUser.token,
      );
    } else {
      updatedClass = yield requestWrapper(
        "PATCH",
        `classes/`,
        classDetail,
        currentUser.token,
      );
    }

    if (!updatedClass) {
      yield put(updateClassSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew) {
        history.push({ pathname: `/classes/${updatedClass._id}` });
      }
      yield put(updateClassSuccess(updatedClass));
    }
  } catch (err) {
    yield put(updateClassError(true));
  }
}

// Individual exports for testing
export default function* classesSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(LOAD_CLASSES, loadClasses);
  yield takeLatest(UPDATE_CLASS, updateClass);
}
